import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import {AlertAsset, AlertTitle, DisplayBetween, DisplayStart, PrimaryButton, SecondaryButton} from './StyledComponents';
import {DialogTitle} from '@mui/material';
import {GrClose} from 'react-icons/gr';

export default function AlertDialog(props) {

    const deleteItem = () => {
        if (props.onChange) {
            props.onChange();
        }
        props.CloseAlert();
    }

    return (
        <Dialog
            open={props.OpenAlert}
            onClose={props.CloseAlert}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth='sm'
            fullWidth
        >
            <DialogTitle sx={{px: 3, pt: 3}} id="alert-dialog-title">
                <DisplayBetween>
                    <AlertTitle>{props.AlertTitle}</AlertTitle>
                    <div className='ml-10px'><GrClose onClick={props.CloseAlert}/></div>
                </DisplayBetween>
            </DialogTitle>
            <DialogContent sx={{px: 5, pb: 4}}>
                <DisplayBetween>
                    <AlertAsset>
                        <img style={{objectFit:'contain'}} src={props.deletingObj} height={100} width={100}/>
                    </AlertAsset>
                    <div>
                        <DisplayStart>
                            <PrimaryButton className='mr-30px' type='button'
                                           onClick={deleteItem}>Yes</PrimaryButton>
                            <SecondaryButton type='button' onClick={props.CloseAlert}>No</SecondaryButton>
                        </DisplayStart>
                    </div>
                </DisplayBetween>
            </DialogContent>
        </Dialog>
    );
}